import $ from 'jquery';
(function($) {

  $.fn.cCalendar = function(options) {
    let _opts = $.extend({}, $.fn.cCalendar.defaults, options),
      _el = this,
      _id = '#' + _el[0].id,
      _table = $(_id + ' table'),
      _prev = _id + ' ' + _opts.prevClass,
      _next = _id + ' ' + _opts.nextClass,
      _year = _id + ' ' + _opts.yearClass,
      _weekDayName = _opts.weekDayName.split(' '),
      CURRENT_DATE = new Date(),
      d = new Date(),
      daysOfMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

    function _getCalendarStart(dayOfWeek, currentDate) {
      var date = currentDate - 1;
      var startOffset = (date % 7) - dayOfWeek;
      if (startOffset > 0) {
        startOffset -= 7;
      }
      return Math.abs(startOffset);
    }

    function _renderCalendar(startDay, totalDays, currentDate, year, month) {
      var currentRow = 1;
      var currentDay = startDay;
      var $week = _getCalendarRow();
      var $day;
      var i = 1;
      month = month + 1;
      if(month < 10) {
        month = '0' + month;
      }

      for (; i <= totalDays; i++) {
        $day = $week.find('td').eq(currentDay);
        $day.append('<span class="date">'+ i + '<em>（' + _weekDayName[currentDay] + '）</em>' +'</span>');
        let value = i;
        if(value < 10) {
          value = '0' + value;
        }
        $day.attr('data-date', year + '/' + month + '/' + value);
        if (i === currentDate) {
          $day.addClass('currentDate');
        }

        currentDay = ++currentDay % 7;
        if (currentDay === 0 && (i + 1 <= totalDays)) {
          $week = _getCalendarRow();
          currentRow++;
        }

        $day.on('click', function() {
          _opts.onSelect.call(getDateSelect($(this)));
        });
      }
    }

    function getDateSelect($el) {
      return $el.data('date');
    }

    function _getCalendarRow() {
      let _tr = $('<tr></tr>');
      for (var i = 0, len = 7; i < len; i++) {
        _tr.append($('<td></td>'));
      }
      _table.append(_tr);
      return _tr;
    }

    function _renderPrev(month) {
      if (month === 0) {
        month = 12;
      }
      $(_prev).html(_opts.prevIcon + '<strong>' + month + '</strong>' + '月');
    }

    function _renderNext(month) {
      month = month + 2;
      if (month === 13) {
        month = 1;
      }
      $(_next).html('<strong>' + month + '</strong>' + '月' + _opts.nextIcon);
    }

    function _renderWeek() {
      let _tr = $('<tr></tr>');
      for (var i = 0; i < _weekDayName.length; i++) {
        _tr.append($('<th>'+ _weekDayName[i] +'</th>'));
      }
      _table.append(_tr);
    }

    function _rendeYear(year, month) {
      $(_year).html(year + '年' + '<strong>' + (month + 1) + '</strong>' + '<em>月</em>');
    }

    _renderWeek();

    function _init(_opts, _el) {
      var month = d.getUTCMonth();
      var day = d.getUTCDay();
      var year = d.getUTCFullYear();
      var date = d.getUTCDate();
      var totalDaysOfMonth = daysOfMonth[month];
      var dateToHighlight = 0;
      _renderPrev(month);
      _renderNext(month);
      _rendeYear(year, month);

      if (CURRENT_DATE.getUTCMonth() === month && CURRENT_DATE.getUTCFullYear() === year) {
        dateToHighlight = date;
      }
      if (month === 1) {
        if ((year % 100 !== 0) && (year % 4 === 0) || (year % 400 === 0)) {
          totalDaysOfMonth = 29;
        }
      }
      _renderCalendar(_getCalendarStart(day, date), totalDaysOfMonth, dateToHighlight, year, month);
    };

    $(_prev).on('click', prev);
    $(_next).on('click', next);

    function _clear() {
      var $trs = $(_id + ' tr').not(':eq(0)');
      $trs.remove();
      $(_year).empty();
    }

    function navigationHandler(dir) {
      d.setUTCMonth(d.getUTCMonth() + dir);
      _clear();
      _init(_opts, _el);
      return _el;
    }

    function prev() {
      _opts.onPrev.call(navigationHandler(-1));
    }

    function next() {
      _opts.onPrev.call(navigationHandler(1));
    }

    function init() {
      _init(_opts, _el);
      return _el;
    }
    _opts.onInit.call(init());
    return _el;
  };

  $.fn.cCalendar.defaults = {
    prevIcon: '〈',
    nextIcon: '〉',
    prevClass: '.jsPrev',
    nextClass: '.jsNext',
    yearClass: '.jsYear',
    weekDayName: '月 火 水 木 金 土 日',
    onPrev: function() {},
    onNext: function() {},
    onSelect: function() {},
    onInit: function() {},
  };
}(jQuery));
